import { HeroUIProvider } from '@heroui/react'
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from '@/styles/theme'


export function Providers({ children }) {
  return (
    <HeroUIProvider>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </ThemeProvider>
    </HeroUIProvider>
  )
}